<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL
 * @LastEditTime: 2024-02-01 18:21:24
 * @Description: 
-->
<template>
  <div>
    <div>
      {{ info.inner_box_quantity }}{{ info.unit }}/{{
        numberToFixed(info?.inner_box_volume, 4) || '-'
      }}m³
    </div>
    <div>
      {{
        numberToFixed(
          (+info?.inner_box_quantity || 1) * (+info.weight || 0),
          3
        ) || '-'
      }}/{{ numberToFixed(info?.rough_weight, 4) || '-' }}kg
    </div>
    <div>
      {{ info.inner_box_l }}L-{{ info.inner_box_w }}W-{{ info.inner_box_h }}H cm
    </div>
  </div>
</template>

<script>
  // 基础产品盒规格组件
  import { defineComponent } from 'vue'
  import { numberToFixed } from '@/utils/index'
  export default defineComponent({
    name: 'BaseSpecsBox',
    components: {},
    props: {
      info: { type: Object, default: () => {} },
    },
    setup() {
      return {
        numberToFixed,
      }
    },
  })
</script>

<style lang="scss" scoped></style>
